module.exports = __webpack_public_path__ + "static/media/icon1.2c0a63f0.svg";